
import { formatSerbiaTime } from "../config/dayjsConfig";
import { routeEndpoints } from "../helpers/requests/apiEndpoints";
import CustomAxiosInstance from "../middlewares/axios/connectionErrorMiddleware";

const api = CustomAxiosInstance();

const methods = {
  createRoute: (payload) =>
    api.post(routeEndpoints.createRouteUrl, payload).then((res) => res.data),
  updateRoute: (payload) =>
    api
      .put(
        routeEndpoints.updateRouteUrl.replace("{routeId}", payload.routeId),
        payload.routes
      )
      .then((res) => res.data),
  updateRouteOrder: (payload) =>
    api
      .put(routeEndpoints.updateRouteOrderUrl, payload)
      .then((res) => res.data),
  updateRouteAsSent: (payload) =>
    api
      .put(routeEndpoints.updateRouteAsSentUrl, payload)
      .then((res) => res.data),
  getAllRoutes: () =>
    api.get(routeEndpoints.getRoutesUrl).then((res) => res.data),
  getRoutesByRouteId: (payload) =>
    api
      .get(routeEndpoints.getRoutesByRouteIdUrl.replace("{id}", payload))
      .then((res) => res.data),
  getRoutesByDestinationType: (payload) =>
    api
      .get(
        routeEndpoints.getRoutesByDestinationTypeUrl
          .replace("{id}", payload.destinationTypeId)
          .replace("{date}", formatSerbiaTime(payload.date))
          .replace("{search}", payload.search)
      )
      .then((res) => res.data),

  getCancelledRoutes: () =>
    api.get(routeEndpoints.getCancelledRoutesUrl).then((res) => res.data),
  createMarker: (payload) =>
    api.post(routeEndpoints.createMarkerUrl, payload).then((res) => res.data),
  deleteMarker: (payload) =>
    api
      .delete(
        routeEndpoints.deleteMarkerUrl.replace("{id}", payload.id),
        payload
      )
      .then((res) => res.data),
  softDeleteRoute: (payload) =>
    api
      .delete(
        routeEndpoints.softDeleteRouteUrl.replace("{id}", payload.id),
        payload
      )
      .then((res) => res.data),
};

export default methods;
